<template>
    <span v-if="isUnverified" :class="[baseClass, 'is-danger', 'hidden-print']">
        {{ translate("common.unverified") }}
    </span>
    <span
        v-else-if="isDisqualified && status.value === COMPETITOR_COMPETITOR_AUTO_DQ_STATUS"
        :class="[baseClass, 'is-warning', 'hidden-print']"
    >
        {{ translate("common.auto_dq") }}
    </span>
    <span v-else-if="isDisqualified" :class="[baseClass, 'is-warning', 'hidden-print']">
        {{ translate("common.disqualified") }}
    </span>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { COMPETITOR_COMPETITOR_AUTO_DQ_STATUS, Status } from "./Competitors/types";
    import { translate } from "./translations";

    // Props
    const props = defineProps<{
        status: Status;
        baseClass: string;
    }>();

    // Mixin function

    // Computed properties
    const isUnverified = computed(() => !props.status.verified && !props.status.disqualified);
    const isDisqualified = computed(() => props.status.disqualified);
</script>
